import { render, staticRenderFns } from "./UfcStrike.vue?vue&type=template&id=3d8bd00f&"
import script from "./UfcStrike.vue?vue&type=script&lang=js&"
export * from "./UfcStrike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports